import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const neo4j = defineConnector({
  identifier: "neo4j",
  name: "Neo4j",
  tagLine: "Graph database platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () =>
    "https://(?:api\\.neo4j\\.io/.*|[^/]*\\.databases\\.neo4j\\.io/.*)",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: "https://api.neo4j.io/oauth/token",
        method: "POST",
        basicAuth: {
          username: app.config.clientId,
          password: app.secret.clientSecret,
        },
        formBody: {
          grant_type: "client_credentials",
        },
      },
      extract: { from: "jsonPath", paths: ["access_token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Neo4j Aura console](https://console.neo4j.io/), create API credentials (client ID and client secret) under **Account › API Credentials**. See the [API docs](https://neo4j.com/docs/aura/platform/api/overview/) for details.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "configuration", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.neo4j.io/v1/instances",
  },
});
